/**
 * Created by Ivan on 22.09.2026
 */

const Merge2MissionCustomerComponent = function (unit, orders, data) {
    Merge2MissionUnitComponent.call(this, unit);
    this.orders = orders;
    this.completed = (data && data.completed) || 0;

    if (data && data.left) {
        this.generator = this.createGenerator(data);
    }
};

Merge2MissionCustomerComponent.prototype = Object.create(Merge2MissionUnitComponent.prototype);
Merge2MissionCustomerComponent.prototype.constructor = Merge2MissionCustomerComponent;

Merge2MissionCustomerComponent.prototype.isMergeable = function () {
    return false;
};

Merge2MissionCustomerComponent.prototype.getOrder = function () {
    return this.orders[this.completed];
};

Merge2MissionCustomerComponent.prototype.isDone = function () {
    return this.completed >= this.orders.length;
};

Merge2MissionCustomerComponent.prototype.createGenerator = function (data) {
    return new Merge2MissionGeneratorComponent(this.unit, { pool: this.getOrder().drop }, data);
};

Merge2MissionCustomerComponent.prototype.canFeed = function (unit) {
    return !this.isDone() && !this.canMine() && Merge2MissionFamilies.isSameItem(this.getOrder().ingredient, unit);
};

Merge2MissionCustomerComponent.prototype.feed = function () {
    const order = this.getOrder();
    this.generator = this.createGenerator();

    return order.reward;
};

Merge2MissionCustomerComponent.prototype.canMine = function () {
    return Boolean(this.generator);
};

Merge2MissionCustomerComponent.prototype.getTotalCharges = function () {
    return this.generator.getTotalCharges();
};

Merge2MissionCustomerComponent.prototype.getChargesLeft = function () {
    return this.generator.getChargesLeft();
};

Merge2MissionCustomerComponent.prototype.mine = function () {
    const result = this.generator.mine();

    if (!this.generator.canMine()) {
        this.generator = undefined;
        this.completed++;
    }

    return result;
};

Merge2MissionCustomerComponent.prototype.save = function (data) {
    if (this.completed) {
        data.completed = this.completed;
    }

    if (this.generator) {
        this.generator.save(data);
    }
};
